// Generated file, changes will be overwritten!

import { Region, ClassicRegion } from 'common/regions';

interface Realm {
  name: string;
  slug: string;
}

export const REALMS: Record<Region, Realm[]> = {
  EU: [
    { name: 'Aegwynn', slug: 'aegwynn' },
    { name: 'Aerie Peak', slug: 'aerie-peak' },
    { name: 'Agamaggan', slug: 'agamaggan' },
    { name: 'Aggra (Português)', slug: 'aggra-português' },
    { name: 'Aggramar', slug: 'aggramar' },
    { name: "Ahn'Qiraj", slug: 'ahnqiraj' },
    { name: "Al'Akir", slug: 'alakir' },
    { name: 'Alexstrasza', slug: 'alexstrasza' },
    { name: 'Alleria', slug: 'alleria' },
    { name: 'Alonsus', slug: 'alonsus' },
    { name: "Aman'Thul", slug: 'amanthul' },
    { name: 'Ambossar', slug: 'ambossar' },
    { name: 'Anachronos', slug: 'anachronos' },
    { name: 'Anetheron', slug: 'anetheron' },
    { name: 'Antonidas', slug: 'antonidas' },
    { name: "Anub'arak", slug: 'anubarak' },
    { name: 'Arak-arahm', slug: 'arakarahm' },
    { name: 'Arathi', slug: 'arathi' },
    { name: 'Arathor', slug: 'arathor' },
    { name: 'Archimonde', slug: 'archimonde' },
    { name: 'Area 52', slug: 'area-52' },
    { name: 'Argent Dawn', slug: 'argent-dawn' },
    { name: 'Arthas', slug: 'arthas' },
    { name: 'Arygos', slug: 'arygos' },
    { name: 'Aszune', slug: 'aszune' },
    { name: 'Auchindoun', slug: 'auchindoun' },
    { name: 'Azjol-Nerub', slug: 'azjolnerub' },
    { name: 'Azshara', slug: 'azshara' },
    { name: 'Azuremyst', slug: 'azuremyst' },
    { name: 'Baelgun', slug: 'baelgun' },
    { name: 'Balnazzar', slug: 'balnazzar' },
    { name: 'Blackhand', slug: 'blackhand' },
    { name: 'Blackmoore', slug: 'blackmoore' },
    { name: 'Blackrock', slug: 'blackrock' },
    { name: "Blade's Edge", slug: 'blades-edge' },
    { name: 'Bladefist', slug: 'bladefist' },
    { name: 'Bloodfeather', slug: 'bloodfeather' },
    { name: 'Bloodhoof', slug: 'bloodhoof' },
    { name: 'Bloodscalp', slug: 'bloodscalp' },
    { name: 'Blutkessel', slug: 'blutkessel' },
    { name: 'Boulderfist', slug: 'boulderfist' },
    { name: 'Bronze Dragonflight', slug: 'bronze-dragonflight' },
    { name: 'Bronzebeard', slug: 'bronzebeard' },
    { name: 'Burning Blade', slug: 'burning-blade' },
    { name: 'Burning Legion', slug: 'burning-legion' },
    { name: 'Burning Steppes', slug: 'burning-steppes' },
    { name: "C'Thun", slug: 'cthun' },
    { name: 'Chamber of Aspects', slug: 'chamber-of-aspects' },
    { name: 'Chants éternels', slug: 'chants-éternels' },
    { name: "Cho'gall", slug: 'chogall' },
    { name: 'Chromaggus', slug: 'chromaggus' },
    { name: 'Confrérie du Thorium', slug: 'confrérie-du-thorium' },
    { name: 'Conseil des Ombres', slug: 'conseil-des-ombres' },
    { name: 'Crushridge', slug: 'crushridge' },
    { name: 'Culte de la Rive noire', slug: 'culte-de-la-rive-noire' },
    { name: 'Daggerspine', slug: 'daggerspine' },
    { name: 'Dalaran', slug: 'dalaran' },
    { name: 'Dalvengyr', slug: 'dalvengyr' },
    { name: 'Darkmoon Faire', slug: 'darkmoon-faire' },
    { name: 'Darksorrow', slug: 'darksorrow' },
    { name: 'Darkspear', slug: 'darkspear' },
    { name: 'Das Konsortium', slug: 'das-konsortium' },
    { name: 'Das Syndikat', slug: 'das-syndikat' },
    { name: 'Deathwing', slug: 'deathwing' },
    { name: 'Defias Brotherhood', slug: 'defias-brotherhood' },
    { name: 'Dentarg', slug: 'dentarg' },
    { name: 'Der abyssische Rat', slug: 'der-abyssische-rat' },
    { name: 'Der Mithrilorden', slug: 'der-mithrilorden' },
    { name: 'Der Rat von Dalaran', slug: 'der-rat-von-dalaran' },
    { name: 'Destromath', slug: 'destromath' },
    { name: 'Dethecus', slug: 'dethecus' },
    { name: 'Die Aldor', slug: 'die-aldor' },
    { name: 'Die Arguswacht', slug: 'die-arguswacht' },
    { name: 'Die ewige Wacht', slug: 'die-ewige-wacht' },
    { name: 'Die Nachtwache', slug: 'die-nachtwache' },
    { name: 'Die Silberne Hand', slug: 'die-silberne-hand' },
    { name: 'Die Todeskrallen', slug: 'die-todeskrallen' },
    { name: 'Doomhammer', slug: 'doomhammer' },
    { name: 'Draenor', slug: 'draenor' },
    { name: 'Dragonblight', slug: 'dragonblight' },
    { name: 'Dragonmaw', slug: 'dragonmaw' },
    { name: "Drak'thul", slug: 'drakthul' },
    { name: "Drek'Thar", slug: 'drekthar' },
    { name: 'Dun Modr', slug: 'dun-modr' },
    { name: 'Dun Morogh', slug: 'dun-morogh' },
    { name: 'Dunemaul', slug: 'dunemaul' },
    { name: 'Durotan', slug: 'durotan' },
    { name: 'Earthen Ring', slug: 'earthen-ring' },
    { name: 'Echsenkessel', slug: 'echsenkessel' },
    { name: 'Eitrigg', slug: 'eitrigg' },
    { name: "Eldre'Thalas", slug: 'eldrethalas' },
    { name: 'Elune', slug: 'elune' },
    { name: 'Emerald Dream', slug: 'emerald-dream' },
    { name: 'Emeriss', slug: 'emeriss' },
    { name: 'Eonar', slug: 'eonar' },
    { name: 'Eredar', slug: 'eredar' },
    { name: 'Executus', slug: 'executus' },
    { name: 'Exodar', slug: 'exodar' },
    { name: 'Festung der Stürme', slug: 'festung-der-stürme' },
    { name: 'Forscherliga', slug: 'forscherliga' },
    { name: 'Frostmane', slug: 'frostmane' },
    { name: 'Frostmourne', slug: 'frostmourne' },
    { name: 'Frostwhisper', slug: 'frostwhisper' },
    { name: 'Frostwolf', slug: 'frostwolf' },
    { name: 'Garona', slug: 'garona' },
    { name: 'Garrosh', slug: 'garrosh' },
    { name: 'Genjuros', slug: 'genjuros' },
    { name: 'Ghostlands', slug: 'ghostlands' },
    { name: 'Gilneas', slug: 'gilneas' },
    { name: 'Gorgonnash', slug: 'gorgonnash' },
    { name: 'Grim Batol', slug: 'grim-batol' },
    { name: "Gul'dan", slug: 'guldan' },
    { name: 'Hakkar', slug: 'hakkar' },
    { name: 'Haomarush', slug: 'haomarush' },
    { name: 'Hellfire', slug: 'hellfire' },
    { name: 'Hellscream', slug: 'hellscream' },
    { name: 'Hyjal', slug: 'hyjal' },
    { name: 'Illidan', slug: 'illidan' },
    { name: 'Jaedenar', slug: 'jaedenar' },
    { name: "Kael'thas", slug: 'kaelthas' },
    { name: 'Karazhan', slug: 'karazhan' },
    { name: 'Kargath', slug: 'kargath' },
    { name: 'Kazzak', slug: 'kazzak' },
    { name: "Kel'Thuzad", slug: 'kelthuzad' },
    { name: 'Khadgar', slug: 'khadgar' },
    { name: 'Khaz Modan', slug: 'khaz-modan' },
    { name: "Khaz'goroth", slug: 'khazgoroth' },
    { name: "Kil'jaeden", slug: 'kiljaeden' },
    { name: 'Kilrogg', slug: 'kilrogg' },
    { name: 'Kirin Tor', slug: 'kirin-tor' },
    { name: "Kor'gall", slug: 'korgall' },
    { name: "Krag'jin", slug: 'kragjin' },
    { name: 'Krasus', slug: 'krasus' },
    { name: 'Kul Tiras', slug: 'kul-tiras' },
    { name: 'Kult der Verdammten', slug: 'kult-der-verdammten' },
    { name: 'La Croisade écarlate', slug: 'la-croisade-écarlate' },
    { name: 'Laughing Skull', slug: 'laughing-skull' },
    { name: 'Les Clairvoyants', slug: 'les-clairvoyants' },
    { name: 'Les Sentinelles', slug: 'les-sentinelles' },
    { name: 'Lightbringer', slug: 'lightbringer' },
    { name: "Lightning's Blade", slug: 'lightnings-blade' },
    { name: 'Lordaeron', slug: 'lordaeron' },
    { name: 'Los Errantes', slug: 'los-errantes' },
    { name: 'Lothar', slug: 'lothar' },
    { name: 'Madmortem', slug: 'madmortem' },
    { name: 'Magtheridon', slug: 'magtheridon' },
    { name: "Mal'Ganis", slug: 'malganis' },
    { name: 'Malfurion', slug: 'malfurion' },
    { name: 'Malorne', slug: 'malorne' },
    { name: 'Malygos', slug: 'malygos' },
    { name: 'Mannoroth', slug: 'mannoroth' },
    { name: 'Marécage de Zangar', slug: 'marécage-de-zangar' },
    { name: 'Mazrigos', slug: 'mazrigos' },
    { name: 'Medivh', slug: 'medivh' },
    { name: 'Minahonda', slug: 'minahonda' },
    { name: 'Moonglade', slug: 'moonglade' },
    { name: "Mug'thol", slug: 'mugthol' },
    { name: 'Nagrand', slug: 'nagrand' },
    { name: 'Nathrezim', slug: 'nathrezim' },
    { name: 'Naxxramas', slug: 'naxxramas' },
    { name: 'Nazjatar', slug: 'nazjatar' },
    { name: 'Nefarian', slug: 'nefarian' },
    { name: 'Nemesis', slug: 'nemesis' },
    { name: 'Neptulon', slug: 'neptulon' },
    { name: "Ner'zhul", slug: 'nerzhul' },
    { name: "Nera'thor", slug: 'nerathor' },
    { name: 'Nethersturm', slug: 'nethersturm' },
    { name: 'Nordrassil', slug: 'nordrassil' },
    { name: 'Norgannon', slug: 'norgannon' },
    { name: 'Nozdormu', slug: 'nozdormu' },
    { name: 'Onyxia', slug: 'onyxia' },
    { name: 'Outland', slug: 'outland' },
    { name: 'Perenolde', slug: 'perenolde' },
    { name: "Pozzo dell'Eternità", slug: 'pozzo-delleternità' },
    { name: 'Proudmoore', slug: 'proudmoore' },
    { name: "Quel'Thalas", slug: 'quelthalas' },
    { name: 'Ragnaros', slug: 'ragnaros' },
    { name: 'Rajaxx', slug: 'rajaxx' },
    { name: 'Rashgarroth', slug: 'rashgarroth' },
    { name: 'Ravencrest', slug: 'ravencrest' },
    { name: 'Ravenholdt', slug: 'ravenholdt' },
    { name: 'Rexxar', slug: 'rexxar' },
    { name: 'Runetotem', slug: 'runetotem' },
    { name: 'Sanguino', slug: 'sanguino' },
    { name: 'Sargeras', slug: 'sargeras' },
    { name: 'Saurfang', slug: 'saurfang' },
    { name: 'Scarshield Legion', slug: 'scarshield-legion' },
    { name: "Sen'jin", slug: 'senjin' },
    { name: 'Shadowsong', slug: 'shadowsong' },
    { name: 'Shattered Halls', slug: 'shattered-halls' },
    { name: 'Shattered Hand', slug: 'shattered-hand' },
    { name: 'Shattrath', slug: 'shattrath' },
    { name: "Shen'dralar", slug: 'shendralar' },
    { name: 'Silvermoon', slug: 'silvermoon' },
    { name: 'Sinstralis', slug: 'sinstralis' },
    { name: 'Skullcrusher', slug: 'skullcrusher' },
    { name: 'Spinebreaker', slug: 'spinebreaker' },
    { name: 'Spirestone', slug: 'colinas-pardas' },
    { name: 'Sporeggar', slug: 'sporeggar' },
    { name: 'Steamwheedle Cartel', slug: 'steamwheedle-cartel' },
    { name: 'Stormrage', slug: 'stormrage' },
    { name: 'Stormreaver', slug: 'stormreaver' },
    { name: 'Stormscale', slug: 'stormscale' },
    { name: 'Sunstrider', slug: 'sunstrider' },
    { name: 'Suramar', slug: 'suramar' },
    { name: 'Sylvanas', slug: 'sylvanas' },
    { name: 'Taerar', slug: 'taerar' },
    { name: 'Talnivarr', slug: 'talnivarr' },
    { name: 'Tarren Mill', slug: 'tarren-mill' },
    { name: 'Teldrassil', slug: 'teldrassil' },
    { name: 'Temple noir', slug: 'temple-noir' },
    { name: 'Terenas', slug: 'terenas' },
    { name: 'Terokkar', slug: 'terokkar' },
    { name: 'Terrordar', slug: 'terrordar' },
    { name: 'The Maelstrom', slug: 'the-maelstrom' },
    { name: "The Sha'tar", slug: 'the-shatar' },
    { name: 'The Venture Co', slug: 'the-venture-co' },
    { name: 'Theradras', slug: 'theradras' },
    { name: 'Thrall', slug: 'thrall' },
    { name: "Throk'Feroth", slug: 'throkferoth' },
    { name: 'Thunderhorn', slug: 'thunderhorn' },
    { name: 'Tichondrius', slug: 'tichondrius' },
    { name: 'Tirion', slug: 'tirion' },
    { name: 'Todeswache', slug: 'todeswache' },
    { name: 'Trollbane', slug: 'trollbane' },
    { name: 'Turalyon', slug: 'turalyon' },
    { name: "Twilight's Hammer", slug: 'twilights-hammer' },
    { name: 'Twisting Nether', slug: 'twisting-nether' },
    { name: 'Tyrande', slug: 'tyrande' },
    { name: 'Uldaman', slug: 'uldaman' },
    { name: 'Ulduar', slug: 'ulduar' },
    { name: 'Uldum', slug: 'uldum' },
    { name: "Un'Goro", slug: 'ungoro' },
    { name: 'Varimathras', slug: 'varimathras' },
    { name: 'Vashj', slug: 'vashj' },
    { name: "Vek'lor", slug: 'veklor' },
    { name: "Vek'nilash", slug: 'veknilash' },
    { name: "Vol'jin", slug: 'voljin' },
    { name: 'Wildhammer', slug: 'wildhammer' },
    { name: 'Wrathbringer', slug: 'wrathbringer' },
    { name: 'Xavius', slug: 'xavius' },
    { name: 'Ysera', slug: 'ysera' },
    { name: 'Ysondre', slug: 'ysondre' },
    { name: 'Zenedar', slug: 'zenedar' },
    { name: 'Zirkel des Cenarius', slug: 'zirkel-des-cenarius' },
    { name: "Zul'jin", slug: 'zuljin' },
    { name: 'Zuluhed', slug: 'zuluhed' },
    { name: 'Азурегос', slug: 'azuregos' },
    { name: 'Борейская тундра', slug: 'borean-tundra' },
    { name: 'Вечная Песня', slug: 'eversong' },
    { name: 'Галакронд', slug: 'galakrond' },
    { name: 'Голдринн', slug: 'goldrinn' },
    { name: 'Гордунни', slug: 'gordunni' },
    { name: 'Гром', slug: 'grom' },
    { name: 'Дракономор', slug: 'fordragon' },
    { name: 'Король-лич', slug: 'lich-king' },
    { name: 'Пиратская Бухта', slug: 'booty-bay' },
    { name: 'Подземье', slug: 'deepholm' },
    { name: 'Разувий', slug: 'razuvious' },
    { name: 'Ревущий фьорд', slug: 'howling-fjord' },
    { name: 'Свежеватель Душ', slug: 'soulflayer' },
    { name: 'Седогрив', slug: 'greymane' },
    { name: 'Страж Смерти', slug: 'deathguard' },
    { name: 'Термоштепсель', slug: 'thermaplugg' },
    { name: 'Ткач Смерти', slug: 'deathweaver' },
    { name: 'Черный Шрам', slug: 'blackscar' },
    { name: 'Ясеневый лес', slug: 'ashenvale' },
  ],
  KR: [
    { name: '가로나', slug: 'garona' },
    { name: '굴단', slug: 'guldan' },
    { name: '노르간논', slug: 'norgannon' },
    { name: '달라란', slug: 'dalaran' },
    { name: '데스윙', slug: 'deathwing' },
    { name: '듀로탄', slug: 'durotan' },
    { name: '렉사르', slug: 'rexxar' },
    { name: '말퓨리온', slug: 'malfurion' },
    { name: '불타는 군단', slug: 'burning-legion' },
    { name: '세나리우스', slug: 'cenarius' },
    { name: '스톰레이지', slug: 'stormrage' },
    { name: '아즈샤라', slug: 'azshara' },
    { name: '알렉스트라자', slug: 'alexstrasza' },
    { name: '와일드해머', slug: 'wildhammer' },
    { name: '윈드러너', slug: 'windrunner' },
    { name: '줄진', slug: 'zuljin' },
    { name: '하이잘', slug: 'hyjal' },
    { name: '헬스크림', slug: 'hellscream' },
  ],
  TW: [
    { name: '世界之樹', slug: 'world-tree' },
    { name: '亞雷戈斯', slug: 'arygos' },
    { name: '克羅之刃', slug: 'krol-blade' },
    { name: '冰霜之刺', slug: 'frostmane' },
    { name: '冰風崗哨', slug: 'chillwind-point' },
    { name: '地獄吼', slug: 'hellscream' },
    { name: '夜空之歌', slug: 'nightsong' },
    { name: '天空之牆', slug: 'skywall' },
    { name: '寒冰皇冠', slug: 'icecrown' },
    { name: '尖石', slug: 'spirestone' },
    { name: '屠魔山谷', slug: 'demon-fall-canyon' },
    { name: '巨龍之喉', slug: 'dragonmaw' },
    { name: '憤怒使者', slug: 'wrathbringer' },
    { name: '日落沼澤', slug: 'sundown-marsh' },
    { name: '暗影之月', slug: 'shadowmoon' },
    { name: '水晶之刺', slug: 'crystalpine-stinger' },
    { name: '狂熱之刃', slug: 'zealot-blade' },
    { name: '眾星之子', slug: 'queldorei' },
    { name: '米奈希爾', slug: 'menethil' },
    { name: '老馬布蘭契', slug: 'old-blanchy' },
    { name: '聖光之願', slug: 'lights-hope' },
    { name: '血之谷', slug: 'bleeding-hollow' },
    { name: '語風', slug: 'whisperwind' },
    { name: '銀翼要塞', slug: 'silverwing-hold' },
    { name: '阿薩斯', slug: 'arthas' },
    { name: '雲蛟衛', slug: 'order-of-the-cloud-serpent' },
    { name: '雷鱗', slug: 'stormscale' },
  ],
  US: [
    { name: 'Aegwynn', slug: 'aegwynn' },
    { name: 'Aerie Peak', slug: 'aerie-peak' },
    { name: 'Agamaggan', slug: 'agamaggan' },
    { name: 'Aggramar', slug: 'aggramar' },
    { name: 'Akama', slug: 'akama' },
    { name: 'Alexstrasza', slug: 'alexstrasza' },
    { name: 'Alleria', slug: 'alleria' },
    { name: 'Altar of Storms', slug: 'altar-of-storms' },
    { name: 'Alterac Mountains', slug: 'alterac-mountains' },
    { name: "Aman'Thul", slug: 'amanthul' },
    { name: 'Andorhal', slug: 'andorhal' },
    { name: 'Anetheron', slug: 'anetheron' },
    { name: 'Antonidas', slug: 'antonidas' },
    { name: "Anub'arak", slug: 'anubarak' },
    { name: 'Anvilmar', slug: 'anvilmar' },
    { name: 'Arathor', slug: 'arathor' },
    { name: 'Archimonde', slug: 'archimonde' },
    { name: 'Area 52', slug: 'area-52' },
    { name: 'Argent Dawn', slug: 'argent-dawn' },
    { name: 'Arthas', slug: 'arthas' },
    { name: 'Arygos', slug: 'arygos' },
    { name: 'Auchindoun', slug: 'auchindoun' },
    { name: 'Azgalor', slug: 'azgalor' },
    { name: 'Azjol-Nerub', slug: 'azjolnerub' },
    { name: 'Azralon', slug: 'azralon' },
    { name: 'Azshara', slug: 'azshara' },
    { name: 'Azuremyst', slug: 'azuremyst' },
    { name: 'Baelgun', slug: 'baelgun' },
    { name: 'Balnazzar', slug: 'balnazzar' },
    { name: 'Barthilas', slug: 'barthilas' },
    { name: 'Black Dragonflight', slug: 'black-dragonflight' },
    { name: 'Blackhand', slug: 'blackhand' },
    { name: 'Blackrock', slug: 'blackrock' },
    { name: 'Blackwater Raiders', slug: 'blackwater-raiders' },
    { name: 'Blackwing Lair', slug: 'blackwing-lair' },
    { name: "Blade's Edge", slug: 'blades-edge' },
    { name: 'Bladefist', slug: 'bladefist' },
    { name: 'Bleeding Hollow', slug: 'bleeding-hollow' },
    { name: 'Blood Furnace', slug: 'blood-furnace' },
    { name: 'Bloodhoof', slug: 'bloodhoof' },
    { name: 'Bloodscalp', slug: 'bloodscalp' },
    { name: 'Bonechewer', slug: 'bonechewer' },
    { name: 'Borean Tundra', slug: 'borean-tundra' },
    { name: 'Boulderfist', slug: 'boulderfist' },
    { name: 'Bronzebeard', slug: 'bronzebeard' },
    { name: 'Burning Blade', slug: 'burning-blade' },
    { name: 'Burning Legion', slug: 'burning-legion' },
    { name: 'Caelestrasz', slug: 'caelestrasz' },
    { name: 'Cairne', slug: 'cairne' },
    { name: 'Cenarion Circle', slug: 'cenarion-circle' },
    { name: 'Cenarius', slug: 'cenarius' },
    { name: "Cho'gall", slug: 'chogall' },
    { name: 'Chromaggus', slug: 'chromaggus' },
    { name: 'Coilfang', slug: 'coilfang' },
    { name: 'Crushridge', slug: 'crushridge' },
    { name: 'Daggerspine', slug: 'daggerspine' },
    { name: 'Dalaran', slug: 'dalaran' },
    { name: 'Dalvengyr', slug: 'dalvengyr' },
    { name: 'Dark Iron', slug: 'dark-iron' },
    { name: 'Darkspear', slug: 'darkspear' },
    { name: 'Darrowmere', slug: 'darrowmere' },
    { name: "Dath'Remar", slug: 'dathremar' },
    { name: 'Dawnbringer', slug: 'dawnbringer' },
    { name: 'Deathwing', slug: 'deathwing' },
    { name: 'Demon Soul', slug: 'demon-soul' },
    { name: 'Dentarg', slug: 'dentarg' },
    { name: 'Destromath', slug: 'destromath' },
    { name: 'Dethecus', slug: 'dethecus' },
    { name: 'Detheroc', slug: 'detheroc' },
    { name: 'Doomhammer', slug: 'doomhammer' },
    { name: 'Draenor', slug: 'draenor' },
    { name: 'Dragonblight', slug: 'dragonblight' },
    { name: 'Dragonmaw', slug: 'dragonmaw' },
    { name: "Drak'Tharon", slug: 'draktharon' },
    { name: "Drak'thul", slug: 'drakthul' },
    { name: 'Draka', slug: 'draka' },
    { name: 'Drakkari', slug: 'drakkari' },
    { name: 'Dreadmaul', slug: 'dreadmaul' },
    { name: 'Drenden', slug: 'drenden' },
    { name: 'Dunemaul', slug: 'dunemaul' },
    { name: 'Durotan', slug: 'durotan' },
    { name: 'Duskwood', slug: 'duskwood' },
    { name: 'Earthen Ring', slug: 'earthen-ring' },
    { name: 'Echo Isles', slug: 'echo-isles' },
    { name: 'Eitrigg', slug: 'eitrigg' },
    { name: "Eldre'Thalas", slug: 'eldrethalas' },
    { name: 'Elune', slug: 'elune' },
    { name: 'Emerald Dream', slug: 'emerald-dream' },
    { name: 'Eonar', slug: 'eonar' },
    { name: 'Eredar', slug: 'eredar' },
    { name: 'Executus', slug: 'executus' },
    { name: 'Exodar', slug: 'exodar' },
    { name: 'Farstriders', slug: 'farstriders' },
    { name: 'Feathermoon', slug: 'feathermoon' },
    { name: 'Fenris', slug: 'fenris' },
    { name: 'Firetree', slug: 'firetree' },
    { name: 'Fizzcrank', slug: 'fizzcrank' },
    { name: 'Frostmane', slug: 'frostmane' },
    { name: 'Frostmourne', slug: 'frostmourne' },
    { name: 'Frostwolf', slug: 'frostwolf' },
    { name: 'Galakrond', slug: 'galakrond' },
    { name: 'Gallywix', slug: 'gallywix' },
    { name: 'Garithos', slug: 'garithos' },
    { name: 'Garona', slug: 'garona' },
    { name: 'Garrosh', slug: 'garrosh' },
    { name: 'Ghostlands', slug: 'ghostlands' },
    { name: 'Gilneas', slug: 'gilneas' },
    { name: 'Gnomeregan', slug: 'gnomeregan' },
    { name: 'Goldrinn', slug: 'goldrinn' },
    { name: 'Gorefiend', slug: 'gorefiend' },
    { name: 'Gorgonnash', slug: 'gorgonnash' },
    { name: 'Greymane', slug: 'greymane' },
    { name: 'Grizzly Hills', slug: 'grizzly-hills' },
    { name: "Gul'dan", slug: 'guldan' },
    { name: 'Gundrak', slug: 'gundrak' },
    { name: 'Gurubashi', slug: 'gurubashi' },
    { name: 'Hakkar', slug: 'hakkar' },
    { name: 'Haomarush', slug: 'haomarush' },
    { name: 'Hellscream', slug: 'hellscream' },
    { name: 'Hydraxis', slug: 'hydraxis' },
    { name: 'Hyjal', slug: 'hyjal' },
    { name: 'Icecrown', slug: 'icecrown' },
    { name: 'Illidan', slug: 'illidan' },
    { name: 'Jaedenar', slug: 'jaedenar' },
    { name: "Jubei'Thos", slug: 'jubeithos' },
    { name: "Kael'thas", slug: 'kaelthas' },
    { name: 'Kalecgos', slug: 'kalecgos' },
    { name: 'Kargath', slug: 'kargath' },
    { name: "Kel'Thuzad", slug: 'kelthuzad' },
    { name: 'Khadgar', slug: 'khadgar' },
    { name: 'Khaz Modan', slug: 'khaz-modan' },
    { name: "Khaz'goroth", slug: 'khazgoroth' },
    { name: "Kil'jaeden", slug: 'kiljaeden' },
    { name: 'Kilrogg', slug: 'kilrogg' },
    { name: 'Kirin Tor', slug: 'kirin-tor' },
    { name: 'Korgath', slug: 'korgath' },
    { name: 'Korialstrasz', slug: 'korialstrasz' },
    { name: 'Kul Tiras', slug: 'kul-tiras' },
    { name: 'Laughing Skull', slug: 'laughing-skull' },
    { name: 'Lethon', slug: 'lethon' },
    { name: 'Lightbringer', slug: 'lightbringer' },
    { name: "Lightning's Blade", slug: 'lightnings-blade' },
    { name: 'Lightninghoof', slug: 'lightninghoof' },
    { name: 'Llane', slug: 'llane' },
    { name: 'Lothar', slug: 'lothar' },
    { name: 'Madoran', slug: 'madoran' },
    { name: 'Maelstrom', slug: 'maelstrom' },
    { name: 'Magtheridon', slug: 'magtheridon' },
    { name: 'Maiev', slug: 'maiev' },
    { name: "Mal'Ganis", slug: 'malganis' },
    { name: 'Malfurion', slug: 'malfurion' },
    { name: 'Malorne', slug: 'malorne' },
    { name: 'Malygos', slug: 'malygos' },
    { name: 'Mannoroth', slug: 'mannoroth' },
    { name: 'Medivh', slug: 'medivh' },
    { name: 'Misha', slug: 'misha' },
    { name: "Mok'Nathal", slug: 'moknathal' },
    { name: 'Moon Guard', slug: 'moon-guard' },
    { name: 'Moonrunner', slug: 'moonrunner' },
    { name: "Mug'thol", slug: 'mugthol' },
    { name: 'Muradin', slug: 'muradin' },
    { name: 'Nagrand', slug: 'nagrand' },
    { name: 'Nathrezim', slug: 'nathrezim' },
    { name: 'Nazgrel', slug: 'nazgrel' },
    { name: 'Nazjatar', slug: 'nazjatar' },
    { name: 'Nemesis', slug: 'nemesis' },
    { name: "Ner'zhul", slug: 'nerzhul' },
    { name: 'Nesingwary', slug: 'nesingwary' },
    { name: 'Nordrassil', slug: 'nordrassil' },
    { name: 'Norgannon', slug: 'norgannon' },
    { name: 'Onyxia', slug: 'onyxia' },
    { name: 'Perenolde', slug: 'perenolde' },
    { name: 'Proudmoore', slug: 'proudmoore' },
    { name: "Quel'dorei", slug: 'queldorei' },
    { name: "Quel'Thalas", slug: 'quelthalas' },
    { name: 'Ragnaros', slug: 'ragnaros' },
    { name: 'Ravencrest', slug: 'ravencrest' },
    { name: 'Ravenholdt', slug: 'ravenholdt' },
    { name: 'Rexxar', slug: 'rexxar' },
    { name: 'Rivendare', slug: 'rivendare' },
    { name: 'Runetotem', slug: 'runetotem' },
    { name: 'Sargeras', slug: 'sargeras' },
    { name: 'Saurfang', slug: 'saurfang' },
    { name: 'Scarlet Crusade', slug: 'scarlet-crusade' },
    { name: 'Scilla', slug: 'scilla' },
    { name: "Sen'jin", slug: 'senjin' },
    { name: 'Sentinels', slug: 'sentinels' },
    { name: 'Shadow Council', slug: 'shadow-council' },
    { name: 'Shadowmoon', slug: 'shadowmoon' },
    { name: 'Shadowsong', slug: 'shadowsong' },
    { name: 'Shandris', slug: 'shandris' },
    { name: 'Shattered Halls', slug: 'shattered-halls' },
    { name: 'Shattered Hand', slug: 'shattered-hand' },
    { name: "Shu'halo", slug: 'shuhalo' },
    { name: 'Silver Hand', slug: 'silver-hand' },
    { name: 'Silvermoon', slug: 'silvermoon' },
    { name: 'Sisters of Elune', slug: 'sisters-of-elune' },
    { name: 'Skullcrusher', slug: 'skullcrusher' },
    { name: 'Skywall', slug: 'skywall' },
    { name: 'Smolderthorn', slug: 'smolderthorn' },
    { name: 'Spinebreaker', slug: 'spinebreaker' },
    { name: 'Spirestone', slug: 'spirestone' },
    { name: 'Staghelm', slug: 'staghelm' },
    { name: 'Steamwheedle Cartel', slug: 'steamwheedle-cartel' },
    { name: 'Stonemaul', slug: 'stonemaul' },
    { name: 'Stormrage', slug: 'stormrage' },
    { name: 'Stormreaver', slug: 'stormreaver' },
    { name: 'Stormscale', slug: 'stormscale' },
    { name: 'Suramar', slug: 'suramar' },
    { name: 'Tanaris', slug: 'tanaris' },
    { name: 'Terenas', slug: 'terenas' },
    { name: 'Terokkar', slug: 'terokkar' },
    { name: 'Thaurissan', slug: 'thaurissan' },
    { name: 'The Forgotten Coast', slug: 'the-forgotten-coast' },
    { name: 'The Scryers', slug: 'the-scryers' },
    { name: 'The Underbog', slug: 'the-underbog' },
    { name: 'The Venture Co', slug: 'the-venture-co' },
    { name: 'Thorium Brotherhood', slug: 'thorium-brotherhood' },
    { name: 'Thrall', slug: 'thrall' },
    { name: 'Thunderhorn', slug: 'thunderhorn' },
    { name: 'Thunderlord', slug: 'thunderlord' },
    { name: 'Tichondrius', slug: 'tichondrius' },
    { name: 'Tol Barad', slug: 'tol-barad' },
    { name: 'Tortheldrin', slug: 'tortheldrin' },
    { name: 'Trollbane', slug: 'trollbane' },
    { name: 'Turalyon', slug: 'turalyon' },
    { name: 'Twisting Nether', slug: 'twisting-nether' },
    { name: 'Uldaman', slug: 'uldaman' },
    { name: 'Uldum', slug: 'uldum' },
    { name: 'Undermine', slug: 'undermine' },
    { name: 'Ursin', slug: 'ursin' },
    { name: 'Uther', slug: 'uther' },
    { name: 'Vashj', slug: 'vashj' },
    { name: "Vek'nilash", slug: 'veknilash' },
    { name: 'Velen', slug: 'velen' },
    { name: 'Warsong', slug: 'warsong' },
    { name: 'Whisperwind', slug: 'whisperwind' },
    { name: 'Wildhammer', slug: 'wildhammer' },
    { name: 'Windrunner', slug: 'windrunner' },
    { name: 'Winterhoof', slug: 'winterhoof' },
    { name: 'Wyrmrest Accord', slug: 'wyrmrest-accord' },
    { name: 'Ysera', slug: 'ysera' },
    { name: 'Ysondre', slug: 'ysondre' },
    { name: 'Zangarmarsh', slug: 'zangarmarsh' },
    { name: "Zul'jin", slug: 'zuljin' },
    { name: 'Zuluhed', slug: 'zuluhed' },
  ],
  CN: [
    { name: '万色星辰', slug: '万色星辰' },
    { name: '世界之树', slug: '世界之树' },
    { name: '丹莫德', slug: '丹莫德' },
    { name: '主宰之剑', slug: '主宰之剑' },
    { name: '亚雷戈斯', slug: '亚雷戈斯' },
    { name: '亡语者', slug: '亡语者' },
    { name: '伊兰尼库斯', slug: '伊兰尼库斯' },
    { name: '伊利丹', slug: '伊利丹' },
    { name: '伊森利恩', slug: '伊森利恩' },
    { name: '伊森德雷', slug: '伊森德雷' },
    { name: '伊瑟拉', slug: '伊瑟拉' },
    { name: '伊莫塔尔', slug: '伊莫塔尔' },
    { name: '伊萨里奥斯', slug: '伊萨里奥斯' },
    { name: '元素之力', slug: '元素之力' },
    { name: '克尔苏加德', slug: '克尔苏加德' },
    { name: '克洛玛古斯', slug: '克洛玛古斯' },
    { name: '克苏恩', slug: '克苏恩' },
    { name: '兰娜瑟尔', slug: '兰娜瑟尔' },
    { name: '军团要塞', slug: '军团要塞' },
    { name: '冬寒', slug: '冬寒' },
    { name: '冬拥湖', slug: '冬拥湖' },
    { name: '冬泉谷', slug: '冬泉谷' },
    { name: '冰川之拳', slug: '冰川之拳' },
    { name: '冰霜之刃', slug: '冰霜之刃' },
    { name: '冰风岗', slug: '冰风岗' },
    { name: '凤凰之神', slug: '凤凰之神' },
    { name: '凯尔萨斯', slug: '凯尔萨斯' },
    { name: '凯恩血蹄', slug: '凯恩血蹄' },
    { name: '刀塔', slug: '刀塔' },
    { name: '利刃之拳', slug: '利刃之拳' },
    { name: '刺骨利刃', slug: '刺骨利刃' },
    { name: '加兹鲁维', slug: '加兹鲁维' },
    { name: '加基森', slug: '加基森' },
    { name: '加尔', slug: '加尔' },
    { name: '加德纳尔', slug: '加德纳尔' },
    { name: '加里索斯', slug: '加里索斯' },
    { name: '勇士岛', slug: '勇士岛' },
    { name: '千针石林', slug: '千针石林' },
    { name: '午夜之镰', slug: '午夜之镰' },
    { name: '卡德加', slug: '卡德加' },
    { name: '卡德罗斯', slug: '卡德罗斯' },
    { name: '卡扎克', slug: '卡扎克' },
    { name: '卡拉赞', slug: '卡拉赞' },
    { name: '卡珊德拉', slug: '卡珊德拉' },
    { name: '厄祖玛特', slug: '厄祖玛特' },
    { name: '双子峰', slug: '双子峰' },
    { name: '古加尔', slug: '古加尔' },
    { name: '古尔丹', slug: '古尔丹' },
    { name: '古拉巴什', slug: '古拉巴什' },
    { name: '古达克', slug: '古达克' },
    { name: '哈兰', slug: '哈兰' },
    { name: '哈卡', slug: '哈卡' },
    { name: '噬灵沼泽', slug: '噬灵沼泽' },
    { name: '嚎风峡湾', slug: '嚎风峡湾' },
    { name: '回音山', slug: '回音山' },
    { name: '国王之谷', slug: '国王之谷' },
    { name: '图拉扬', slug: '图拉扬' },
    { name: '圣火神殿', slug: '圣火神殿' },
    { name: '地狱之石', slug: '地狱之石' },
    { name: '地狱咆哮', slug: '地狱咆哮' },
    { name: '埃克索图斯', slug: '埃克索图斯' },
    { name: '埃加洛尔', slug: '埃加洛尔' },
    { name: '埃德萨拉', slug: '埃德萨拉' },
    { name: '埃苏雷格', slug: '埃苏雷格' },
    { name: '埃雷达尔', slug: '埃雷达尔' },
    { name: '埃霍恩', slug: '埃霍恩' },
    { name: '基尔加丹', slug: '基尔加丹' },
    { name: '基尔罗格', slug: '基尔罗格' },
    { name: '塔伦米尔', slug: '塔伦米尔' },
    { name: '塔纳利斯', slug: '塔纳利斯' },
    { name: '塞拉摩', slug: '塞拉摩' },
    { name: '塞拉赞恩', slug: '塞拉赞恩' },
    { name: '塞泰克', slug: '塞泰克' },
    { name: '塞纳里奥', slug: '塞纳里奥' },
    { name: '壁炉谷', slug: '壁炉谷' },
    { name: '夏维安', slug: '夏维安' },
    { name: '外域', slug: '外域' },
    { name: '大地之怒', slug: '大地之怒' },
    { name: '大漩涡', slug: '大漩涡' },
    { name: '天空之墙', slug: '天空之墙' },
    { name: '太阳之井', slug: '太阳之井' },
    { name: '夺灵者', slug: '夺灵者' },
    { name: '奈法利安', slug: '奈法利安' },
    { name: '奎尔丹纳斯', slug: '奎尔丹纳斯' },
    { name: '奎尔萨拉斯', slug: '奎尔萨拉斯' },
    { name: '奥妮克希亚', slug: '奥妮克希亚' },
    { name: '奥尔加隆', slug: '奥尔加隆' },
    { name: '奥拉基尔', slug: '奥拉基尔' },
    { name: '奥斯里安', slug: '奥斯里安' },
    { name: '奥特兰克', slug: '奥特兰克' },
    { name: '奥蕾莉亚', slug: '奥蕾莉亚' },
    { name: '奥达曼', slug: '奥达曼' },
    { name: '奥金顿', slug: '奥金顿' },
    { name: '守护之剑', slug: '守护之剑' },
    { name: '安其拉', slug: '安其拉' },
    { name: '安加萨', slug: '安加萨' },
    { name: '安多哈尔', slug: '安多哈尔' },
    { name: '安威玛尔', slug: '安威玛尔' },
    { name: '安戈洛', slug: '安戈洛' },
    { name: '安格博达', slug: '安格博达' },
    { name: '安纳塞隆', slug: '安纳塞隆' },
    { name: '安苏', slug: '安苏' },
    { name: '密林游侠', slug: '密林游侠' },
    { name: '寒冰皇冠', slug: '寒冰皇冠' },
    { name: '尘风峡谷', slug: '尘风峡谷' },
    { name: '屠魔山谷', slug: '屠魔山谷' },
    { name: '山丘之王', slug: '山丘之王' },
    { name: '岩石巨塔', slug: '岩石巨塔' },
    { name: '巨龙之吼', slug: '巨龙之吼' },
    { name: '巫妖之王', slug: '巫妖之王' },
    { name: '巴尔古恩', slug: '巴尔古恩' },
    { name: '巴瑟拉斯', slug: '巴瑟拉斯' },
    { name: '巴纳扎尔', slug: '巴纳扎尔' },
    { name: '布兰卡德', slug: '布兰卡德' },
    { name: '布莱克摩', slug: '布莱克摩' },
    { name: '布莱恩', slug: '布莱恩' },
    { name: '布鲁塔卢斯', slug: '布鲁塔卢斯' },
    { name: '希尔瓦娜斯', slug: '希尔瓦娜斯' },
    { name: '希雷诺斯', slug: '希雷诺斯' },
    { name: '幽暗沼泽', slug: '幽暗沼泽' },
    { name: '库尔提拉斯', slug: '库尔提拉斯' },
    { name: '库德兰', slug: '库德兰' },
    { name: '弗塞雷迦', slug: '弗塞雷迦' },
    { name: '影之哀伤', slug: '影之哀伤' },
    { name: '影牙要塞', slug: '影牙要塞' },
    { name: '德拉诺', slug: '德拉诺' },
    { name: '恐怖图腾', slug: '恐怖图腾' },
    { name: '恶魔之翼', slug: '恶魔之翼' },
    { name: '恶魔之魂', slug: '恶魔之魂' },
    { name: '戈古纳斯', slug: '戈古纳斯' },
    { name: '戈提克', slug: '戈提克' },
    { name: '戈杜尼', slug: '戈杜尼' },
    { name: '战歌', slug: '战歌' },
    { name: '扎拉赞恩', slug: '扎拉赞恩' },
    { name: '托塞德林', slug: '托塞德林' },
    { name: '托尔巴拉德', slug: '托尔巴拉德' },
    { name: '拉文凯斯', slug: '拉文凯斯' },
    { name: '拉文霍德', slug: '拉文霍德' },
    { name: '拉格纳洛斯', slug: '拉格纳洛斯' },
    { name: '拉贾克斯', slug: '拉贾克斯' },
    { name: '提尔之手', slug: '提尔之手' },
    { name: '提瑞斯法', slug: '提瑞斯法' },
    { name: '摩摩尔', slug: '摩摩尔' },
    { name: '斩魔者', slug: '斩魔者' },
    { name: '斯克提斯', slug: '斯克提斯' },
    { name: '斯坦索姆', slug: '斯坦索姆' },
    { name: '无尽之海', slug: '无尽之海' },
    { name: '无底海渊', slug: '无底海渊' },
    { name: '日落沼泽', slug: '日落沼泽' },
    { name: '普瑞斯托', slug: '普瑞斯托' },
    { name: '普罗德摩', slug: '普罗德摩' },
    { name: '暗影之月', slug: '暗影之月' },
    { name: '暗影议会', slug: '暗影议会' },
    { name: '暗影迷宫', slug: '暗影迷宫' },
    { name: '暮色森林', slug: '暮色森林' },
    { name: '暴风祭坛', slug: '暴风祭坛' },
    { name: '月光林地', slug: '月光林地' },
    { name: '月神殿', slug: '月神殿' },
    { name: '末日祷告祭坛', slug: '末日祷告祭坛' },
    { name: '末日行者', slug: '末日行者' },
    { name: '朵丹尼尔', slug: '朵丹尼尔' },
    { name: '杜隆坦', slug: '杜隆坦' },
    { name: '格瑞姆巴托', slug: '格瑞姆巴托' },
    { name: '格雷迈恩', slug: '格雷迈恩' },
    { name: '格鲁尔', slug: '格鲁尔' },
    { name: '桑德兰', slug: '桑德兰' },
    { name: '梅尔加尼', slug: '梅尔加尼' },
    { name: '梦境之树', slug: '梦境之树' },
    { name: '森金', slug: '森金' },
    { name: '死亡之翼', slug: '死亡之翼' },
    { name: '死亡之门', slug: '死亡之门' },
    { name: '死亡熔炉', slug: '死亡熔炉' },
    { name: '毁灭之锤', slug: '毁灭之锤' },
    { name: '水晶之刺', slug: '水晶之刺' },
    { name: '永夜港', slug: '永夜港' },
    { name: '永恒之井', slug: '永恒之井' },
    { name: '沙怒', slug: '沙怒' },
    { name: '法拉希姆', slug: '法拉希姆' },
    { name: '泰兰德', slug: '泰兰德' },
    { name: '泰拉尔', slug: '泰拉尔' },
    { name: '洛丹伦', slug: '洛丹伦' },
    { name: '洛肯', slug: '洛肯' },
    { name: '洛萨', slug: '洛萨' },
    { name: '海克泰尔', slug: '海克泰尔' },
    { name: '海加尔', slug: '海加尔' },
    { name: '海达希亚', slug: '海达希亚' },
    { name: '浸毒之骨', slug: '浸毒之骨' },
    { name: '深渊之喉', slug: '深渊之喉' },
    { name: '深渊之巢', slug: '深渊之巢' },
    { name: '激流之傲', slug: '激流之傲' },
    { name: '激流堡', slug: '激流堡' },
    { name: '火喉', slug: '火喉' },
    { name: '火烟之谷', slug: '火烟之谷' },
    { name: '火焰之树', slug: '火焰之树' },
    { name: '火羽山', slug: '火羽山' },
    { name: '灰烬使者', slug: '灰烬使者' },
    { name: '灰谷', slug: '灰谷' },
    { name: '烈焰峰', slug: '烈焰峰' },
    { name: '烈焰荆棘', slug: '烈焰荆棘' },
    { name: '熊猫酒仙', slug: '熊猫酒仙' },
    { name: '熔火之心', slug: '熔火之心' },
    { name: '蒸汽地窟', slug: '蒸汽地窟' },
    { name: '熵魔', slug: '熵魔' },
    { name: '燃烧之刃', slug: '燃烧之刃' },
    { name: '燃烧军团', slug: '燃烧军团' },
    { name: '燃烧平原', slug: '燃烧平原' },
    { name: '爱斯特纳', slug: '爱斯特纳' },
    { name: '狂热之刃', slug: '狂热之刃' },
    { name: '狂风峭壁', slug: '狂风峭壁' },
    { name: '玛克扎尔', slug: '玛克扎尔' },
    { name: '玛多兰', slug: '玛多兰' },
    { name: '玛格曼达', slug: '玛格曼达' },
    { name: '玛格索尔', slug: '玛格索尔' },
    { name: '玛法里奥', slug: '玛法里奥' },
    { name: '玛洛加尔', slug: '玛洛加尔' },
    { name: '玛瑟里顿', slug: '玛瑟里顿' },
    { name: '玛诺洛斯', slug: '玛诺洛斯' },
    { name: '玛里苟斯', slug: '玛里苟斯' },
    { name: '瑞文戴尔', slug: '瑞文戴尔' },
    { name: '瑟玛普拉格', slug: '瑟玛普拉格' },
    { name: '瑟莱德丝', slug: '瑟莱德丝' },
    { name: '瓦丝琪', slug: '瓦丝琪' },
    { name: '瓦拉斯塔兹', slug: '瓦拉斯塔兹' },
    { name: '瓦里玛萨斯', slug: '瓦里玛萨斯' },
    { name: '甜水绿洲', slug: '甜水绿洲' },
    { name: '生态船', slug: '生态船' },
    { name: '白银之手', slug: '白银之手' },
    { name: '白骨荒野', slug: '白骨荒野' },
    { name: '盖斯', slug: '盖斯' },
    { name: '石爪峰', slug: '石爪峰' },
    { name: '石锤', slug: '石锤' },
    { name: '破碎大厅', slug: '破碎大厅' },
    { name: '破碎岭', slug: '破碎岭' },
    { name: '祖尔金', slug: '祖尔金' },
    { name: '祖达克', slug: '祖达克' },
    { name: '祖阿曼', slug: '祖阿曼' },
    { name: '神圣之歌', slug: '神圣之歌' },
    { name: '禁魔监狱', slug: '禁魔监狱' },
    { name: '穆戈尔', slug: '穆戈尔' },
    { name: '符文图腾', slug: '符文图腾' },
    { name: '米奈希尔', slug: '米奈希尔' },
    { name: '索拉丁', slug: '索拉丁' },
    { name: '索瑞森', slug: '索瑞森' },
    { name: '红云台地', slug: '红云台地' },
    { name: '红龙军团', slug: '红龙军团' },
    { name: '红龙女王', slug: '红龙女王' },
    { name: '纳克萨玛斯', slug: '纳克萨玛斯' },
    { name: '纳沙塔尔', slug: '纳沙塔尔' },
    { name: '织亡者', slug: '织亡者' },
    { name: '维克尼拉斯', slug: '维克尼拉斯' },
    { name: '罗宁', slug: '罗宁' },
    { name: '罗曼斯', slug: '罗曼斯' },
    { name: '羽月', slug: '羽月' },
    { name: '翡翠梦境', slug: '翡翠梦境' },
    { name: '耐克鲁斯', slug: '耐克鲁斯' },
    { name: '耐奥祖', slug: '耐奥祖' },
    { name: '耐普图隆', slug: '耐普图隆' },
    { name: '耐萨里奥', slug: '耐萨里奥' },
    { name: '耳语海岸', slug: '耳语海岸' },
    { name: '能源舰', slug: '能源舰' },
    { name: '自由之风', slug: '自由之风' },
    { name: '艾森娜', slug: '艾森娜' },
    { name: '艾欧纳尔', slug: '艾欧纳尔' },
    { name: '艾维娜', slug: '艾维娜' },
    { name: '艾苏恩', slug: '艾苏恩' },
    { name: '艾莫莉丝', slug: '艾莫莉丝' },
    { name: '艾萨拉', slug: '艾萨拉' },
    { name: '艾露恩', slug: '艾露恩' },
    { name: '芬里斯', slug: '芬里斯' },
    { name: '苏塔恩', slug: '苏塔恩' },
    { name: '范克里夫', slug: '范克里夫' },
    { name: '范达尔鹿盔', slug: '范达尔鹿盔' },
    { name: '荆棘谷', slug: '荆棘谷' },
    { name: '莉亚德琳', slug: '莉亚德琳' },
    { name: '莫加尔', slug: '莫加尔' },
    { name: '莫德雷萨', slug: '莫德雷萨' },
    { name: '莫格莱尼', slug: '莫格莱尼' },
    { name: '莱索恩', slug: '莱索恩' },
    { name: '菲拉斯', slug: '菲拉斯' },
    { name: '菲米丝', slug: '菲米丝' },
    { name: '萨塔里奥', slug: '萨塔里奥' },
    { name: '萨尔', slug: '萨尔' },
    { name: '萨格拉斯', slug: '萨格拉斯' },
    { name: '萨菲隆', slug: '萨菲隆' },
    { name: '蓝龙军团', slug: '蓝龙军团' },
    { name: '藏宝海湾', slug: '藏宝海湾' },
    { name: '蜘蛛王国', slug: '蜘蛛王国' },
    { name: '血吼', slug: '血吼' },
    { name: '血槌', slug: '血槌' },
    { name: '血牙魔王', slug: '血牙魔王' },
    { name: '血环', slug: '血环' },
    { name: '血羽', slug: '血羽' },
    { name: '血色十字军', slug: '血色十字军' },
    { name: '血顶', slug: '血顶' },
    { name: '试炼之环', slug: '试炼之环' },
    { name: '诺兹多姆', slug: '诺兹多姆' },
    { name: '诺森德', slug: '诺森德' },
    { name: '诺莫瑞根', slug: '诺莫瑞根' },
    { name: '贫瘠之地', slug: '贫瘠之地' },
    { name: '踏梦者', slug: '踏梦者' },
    { name: '轻风之语', slug: '轻风之语' },
    { name: '达克萨隆', slug: '达克萨隆' },
    { name: '达基萨斯', slug: '达基萨斯' },
    { name: '达尔坎', slug: '达尔坎' },
    { name: '达文格尔', slug: '达文格尔' },
    { name: '达斯雷玛', slug: '达斯雷玛' },
    { name: '达纳斯', slug: '达纳斯' },
    { name: '达隆米尔', slug: '达隆米尔' },
    { name: '迅捷微风', slug: '迅捷微风' },
    { name: '远古海滩', slug: '远古海滩' },
    { name: '迦拉克隆', slug: '迦拉克隆' },
    { name: '迦玛兰', slug: '迦玛兰' },
    { name: '迦罗娜', slug: '迦罗娜' },
    { name: '迦顿', slug: '迦顿' },
    { name: '迪托马斯', slug: '迪托马斯' },
    { name: '迪瑟洛克', slug: '迪瑟洛克' },
    { name: '迪门修斯', slug: '迪门修斯' },
    { name: '逐日者', slug: '逐日者' },
    { name: '通灵学院', slug: '通灵学院' },
    { name: '遗忘海岸', slug: '遗忘海岸' },
    { name: '金度', slug: '金度' },
    { name: '金色平原', slug: '金色平原' },
    { name: '铜龙军团', slug: '铜龙军团' },
    { name: '银月', slug: '银月' },
    { name: '银松森林', slug: '银松森林' },
    { name: '闪电之刃', slug: '闪电之刃' },
    { name: '阿克蒙德', slug: '阿克蒙德' },
    { name: '阿努巴拉克', slug: '阿努巴拉克' },
    { name: '阿卡玛', slug: '阿卡玛' },
    { name: '阿古斯', slug: '阿古斯' },
    { name: '阿尔萨斯', slug: '阿尔萨斯' },
    { name: '阿扎达斯', slug: '阿扎达斯' },
    { name: '阿拉希', slug: '阿拉希' },
    { name: '阿拉索', slug: '阿拉索' },
    { name: '阿斯塔洛', slug: '阿斯塔洛' },
    { name: '阿曼尼', slug: '阿曼尼' },
    { name: '阿格拉玛', slug: '阿格拉玛' },
    { name: '阿比迪斯', slug: '阿比迪斯' },
    { name: '阿纳克洛斯', slug: '阿纳克洛斯' },
    { name: '阿迦玛甘', slug: '阿迦玛甘' },
    { name: '雏龙之翼', slug: '雏龙之翼' },
    { name: '雷克萨', slug: '雷克萨' },
    { name: '雷德', slug: '雷德' },
    { name: '雷斧堡垒', slug: '雷斧堡垒' },
    { name: '雷霆之怒', slug: '雷霆之怒' },
    { name: '雷霆之王', slug: '雷霆之王' },
    { name: '雷霆号角', slug: '雷霆号角' },
    { name: '霍格', slug: '霍格' },
    { name: '霜之哀伤', slug: '霜之哀伤' },
    { name: '霜狼', slug: '霜狼' },
    { name: '风暴之怒', slug: '风暴之怒' },
    { name: '风暴之眼', slug: '风暴之眼' },
    { name: '风暴之鳞', slug: '风暴之鳞' },
    { name: '风暴峭壁', slug: '风暴峭壁' },
    { name: '风暴裂隙', slug: '风暴裂隙' },
    { name: '风行者', slug: '风行者' },
    { name: '鬼雾峰', slug: '鬼雾峰' },
    { name: '鲜血熔炉', slug: '鲜血熔炉' },
    { name: '鹰巢山', slug: '鹰巢山' },
    { name: '麦姆', slug: '麦姆' },
    { name: '麦维影歌', slug: '麦维影歌' },
    { name: '麦迪文', slug: '麦迪文' },
    { name: '黄金之路', slug: '黄金之路' },
    { name: '黑手军团', slug: '黑手军团' },
    { name: '黑暗之矛', slug: '黑暗之矛' },
    { name: '黑暗之门', slug: '黑暗之门' },
    { name: '黑暗虚空', slug: '黑暗虚空' },
    { name: '黑暗魅影', slug: '黑暗魅影' },
    { name: '黑石尖塔', slug: '黑石尖塔' },
    { name: '黑翼之巢', slug: '黑翼之巢' },
    { name: '黑铁', slug: '黑铁' },
    { name: '黑锋哨站', slug: '黑锋哨站' },
    { name: '黑龙军团', slug: '黑龙军团' },
    { name: '龙骨平原', slug: '龙骨平原' },
  ],
};

export const CLASSIC_REALMS: Record<ClassicRegion, Realm[]> = {
  EU: [
    { name: 'Amnennar', slug: 'amnennar' },
    { name: 'Ashbringer', slug: 'ashbringer' },
    { name: 'Auberdine', slug: 'auberdine' },
    { name: 'Earthshaker', slug: 'earthshaker' },
    { name: 'Everlook', slug: 'everlook' },
    { name: 'Firemaw', slug: 'firemaw' },
    { name: 'Garalon', slug: 'garalon' },
    { name: 'Gehennas', slug: 'gehennas' },
    { name: 'Giantstalker', slug: 'giantstalker' },
    { name: 'Golemagg', slug: 'golemagg' },
    { name: 'Hoptallus', slug: 'hoptallus' },
    { name: 'Hydraxian Waterlords', slug: 'hydraxian-waterlords' },
    { name: "Jin'do", slug: 'jindo' },
    { name: 'Lakeshire', slug: 'lakeshire' },
    { name: 'Mandokir', slug: 'mandokir' },
    { name: 'Mirage Raceway', slug: 'mirage-raceway' },
    { name: 'Mograine', slug: 'mograine' },
    { name: 'Nethergarde Keep', slug: 'nethergarde-keep' },
    { name: 'Norushen', slug: 'norushen' },
    { name: 'Ook Ook', slug: 'ook-ook' },
    { name: 'Patchwerk', slug: 'patchwerk' },
    { name: 'Pyrewood Village', slug: 'pyrewood-village' },
    { name: 'Razorfen', slug: 'razorfen' },
    { name: "Shek'zeer", slug: 'shekzeer' },
    { name: 'Sulfuron', slug: 'sulfuron' },
    { name: 'Thekal', slug: 'thekal' },
    { name: 'Transcendence', slug: 'transcendence' },
    { name: 'Venoxis', slug: 'venoxis' },
    { name: 'Пламегор', slug: 'flamegor' },
    { name: 'Хроми', slug: 'chromie' },
  ],
  KR: [
    { name: '라그나로스', slug: 'ragnaros' },
    { name: '로크홀라', slug: 'lokholar' },
    { name: '서리한', slug: 'frostmourne' },
    { name: '소금 평원', slug: 'shimmering-flats' },
    { name: '얼음피', slug: 'iceblood' },
  ],
  TW: [
    { name: '伊弗斯', slug: 'ivus' },
    { name: '古雷曼格', slug: 'golemagg' },
    { name: '札里克', slug: 'zeliek' },
    { name: '烏蘇雷', slug: 'wushoolay' },
    { name: '瑪拉頓', slug: 'maraudon' },
    { name: '逐風者', slug: 'windseeker' },
    { name: '阿拉希盆地', slug: 'arathi-basin' },
    { name: '魚人', slug: 'murloc' },
  ],
  US: [
    { name: 'Angerforge', slug: 'angerforge' },
    { name: 'Arugal (AU)', slug: 'arugal-au' },
    { name: 'Ashkandi', slug: 'ashkandi' },
    { name: 'Atiesh', slug: 'atiesh' },
    { name: 'Azuresong', slug: 'azuresong' },
    { name: 'Benediction', slug: 'benediction' },
    { name: 'Bloodsail Buccaneers', slug: 'bloodsail-buccaneers' },
    { name: 'Earthfury', slug: 'earthfury' },
    { name: 'Eranikus', slug: 'eranikus' },
    { name: 'Faerlina', slug: 'faerlina' },
    { name: 'Galakras', slug: 'galakras' },
    { name: 'Grobbulus', slug: 'grobbulus' },
    { name: 'Immerseus', slug: 'immerseus' },
    { name: 'Lei Shen', slug: 'lei-shen' },
    { name: 'Maladath', slug: 'maladath' },
    { name: 'Mankrik', slug: 'mankrik' },
    { name: 'Myzrael', slug: 'myzrael' },
    { name: 'Nazgrim', slug: 'nazgrim' },
    { name: 'Old Blanchy', slug: 'old-blanchy' },
    { name: 'Pagle', slug: 'pagle' },
    { name: 'Ra-den', slug: 'raden' },
    { name: 'Remulos (AU)', slug: 'remulos-au' },
    { name: 'Skyfury', slug: 'skyfury' },
    { name: 'Sulfuras', slug: 'sulfuras' },
    { name: 'Westfall', slug: 'westfall' },
    { name: 'Whitemane', slug: 'whitemane' },
    { name: 'Windseeker', slug: 'windseeker' },
    { name: 'Yojamba (AU)', slug: 'yojamba-au' },
  ],
};
